import React, { Component } from 'react'
import errorImg from '../../assets/images/newui/error-cross.svg'
import successImg from '../../assets/images/newui/success-tick.svg'
import './GeneralMessage.less'

class GeneralMessage extends Component {
    render() {
        return (
            <div className={`general-msg-container ${this.props.type ? this.props.type : 'error'}`} >
                <img src={this.props.type == 'success' ? successImg : errorImg}></img>
                <div>{this.props.message}</div>
            </div>
        )
    }
}

export default GeneralMessage
